// Mantém o texto do botão de adicionar ao carrinho como "Adicionar"
if (window.variantStrings) {
  window.variantStrings.addToCart = 'Adicionar';
} else {
  document.addEventListener('DOMContentLoaded', function () {
    if (window.variantStrings) window.variantStrings.addToCart = 'Adicionar';
  });
}

// INICIO JS PARA SLIDE PAGINA DO PRODUTO

  document.addEventListener('DOMContentLoaded', function () {
    if (typeof Swiper === 'undefined') return;
    
    var prodSlideImgSwiper = new Swiper('.prod-slide-img-swiper', {
      slidesPerView: 1,
      spaceBetween: 0,
      loop: true,
      navigation: {
        nextEl: '.prod-slide-img-button-next',
        prevEl: '.prod-slide-img-button-prev',
      },
    });
  });

// FINAL JS PARA SLIDE PAGINA DO PRODUTO


// INICIO JS PARA BOTÃO DE VARIAÇÃO

  document.addEventListener('DOMContentLoaded', function() {
    var customSecondSelect = document.querySelector(
      '.product-form__input--custom-second-select select'
    );
    if (!customSecondSelect) return; // não está no modo custom

    // Fieldset escondido da 2ª variação (option_index0 == 1)
    var secondFieldset = document.querySelector(
      'fieldset.product-form__input--custom-second-hidden'
    );
    if (!secondFieldset) return;

    var radios = secondFieldset.querySelectorAll('input[type="radio"]');

    // Sincronizar estado inicial: se algum radio está checked, reflete no select
    var checkedRadio = secondFieldset.querySelector('input[type="radio"]:checked');
    if (checkedRadio) {
      customSecondSelect.value = checkedRadio.value;
    }

    // Quando o select mudar, marcamos o radio correspondente e disparamos change
    customSecondSelect.addEventListener('change', function() {
      var value = this.value;

      radios.forEach(function(radio) {
        if (radio.value === value) {
          radio.checked = true;
          // Dispara 'change' para o variant-radios tratar e atualizar a variante
          var event = new Event('change', { bubbles: true });
          radio.dispatchEvent(event);
        }
      });
    });
  });

// FINAL JS PARA BOTÃO DE VARIAÇÃO


// INICIO JS PARA DOTS PAGINA DO PRODUTO

  document.addEventListener('DOMContentLoaded', function() {
    var $mainCarousel = $('#main-media-container.single-product.owl-carousel');
    var $dots = $('.product__media-dots .product__media-dot');
    
    if (!$mainCarousel.length || !$dots.length) return;
    
    // Quando clicar no dot, vai para o slide correspondente
    $dots.on('click', function() {
      var index = parseInt($(this).attr('data-dot-index'), 10) || 0;
      $mainCarousel.trigger('to.owl.carousel', [index, 300, true]);
    });
    
    // Mantém o dot "ativo" sincronizado com o slide atual
    $mainCarousel.on('changed.owl.carousel', function(event) {
      if (!event.item) return;
      var currentIndex = event.item.index;
      
      $dots.removeClass('is-active');
      $dots.eq(currentIndex).addClass('is-active');
    });
    
    // Opcional: marca o primeiro como ativo ao carregar
    $dots.first().addClass('is-active');
  });

// FINAL JS PARA DOTS PAGINA DO PRODUTO


// INICIO JS PARA MOVER CONTEUDOS DO PRODUTO

  document.addEventListener("DOMContentLoaded", () => {
    if (window.innerWidth < 767) {
      const blocotolstoy = document.querySelector('.shopify-block.shopify-app-block:has(tolstoy-stories)');
      const destino = document.querySelector('.product-section.topo-mobile .product__info-container');
      const tolstoy = document.querySelector('.shopify-block.shopify-app-block tolstoy-stories');

      if (blocotolstoy && destino && tolstoy) {
        setTimeout(() => {
          if (tolstoy.innerHTML.trim()) {
            destino.appendChild(blocotolstoy);
          } else {
            tolstoy.style.display = 'none';
          }
        }, 600);
      }
    }

    const richtext = document.querySelector('.richtext_content:has(.read-more-link)');
    const jdgm = document.querySelector('.shopify-block.shopify-app-block:has(.jdgm-widget)');
    const destinoBackground = document.querySelector('.product__info-container-background');

    if (richtext && destinoBackground) {
      destinoBackground.appendChild(richtext);
    }

    if (jdgm && destinoBackground) {
      destinoBackground.appendChild(jdgm);
    }

  });

// FINAL JS PARA MOVER CONTEUDOS DO PRODUTO


// INICIO JS PARA LABEL DE VARIAÇÃO GENERICA

  document.addEventListener('DOMContentLoaded', function() {
    function setupVariantLegendUpdates() {
      document.querySelectorAll('.product-form__input').forEach(function(fieldset) {
        if (!fieldset.querySelector('.varinat-image')) return;

        var legend = fieldset.querySelector('legend.form__label');
        if (!legend) return;

        var radio = fieldset.querySelector('input[type="radio"]');
        if (!radio) return;
        var optionName = radio.name;

        // Adiciona o span de valor selecionado na legend se ainda não existe
        if (!legend.querySelector('.selected-variant-value')) {
          var checked = fieldset.querySelector('input[type="radio"]:checked');
          var span = document.createElement('span');
          span.className = 'selected-variant-value';
          span.setAttribute('data-option-name', optionName);
          span.textContent = ': ' + (checked ? checked.value : '');
          legend.appendChild(span);
        }

        // Atualiza o span ao selecionar uma variação
        fieldset.querySelectorAll('input[type="radio"]').forEach(function(r) {
          r.addEventListener('change', function() {
            if (this.checked) {
              var span = legend.querySelector('.selected-variant-value');
              if (span) span.textContent = ': ' + this.value;
            }
          });
        });
      });
    }

    setupVariantLegendUpdates();

    // Rebinda ao clicar em qualquer swatch (para cobrir casos com re-render)
    document.querySelectorAll('.varinat-image, .variant-image').forEach(function(el) {
      el.addEventListener('click', function() {
        setTimeout(setupVariantLegendUpdates, 150);
      });
    });
  });

// FINAL JS PARA LABEL DE VARIAÇÃO GENERICA



// INICIO JS PARA ALTERAR NOME DAS OPÇÕES SELECT ORDENAÇÃO

(function () {
  const labels = {
    "best-selling": "Mais Vendidos",
    "price-ascending": "Menor Preço",
    "price-descending": "Maior Preço",
    "created-descending": "Lançamentos",
    "created-ascending": "Mais Antigos",
    "title-ascending": "A-Z",
    "title-descending": "Z-A",
    "sale-descending": "Maior Desconto"
  };

  const buttonLabels = {
    "Mais Vendidos": "Mais Vendidos",
    "Preço, do menor para o maior": "Menor Preço",
    "Preço, do mais alto ao mais baixo": "Maior Preço",
    "Data, do novo ao antigo": "Lançamentos",
    "Data, do antigo ao novo": "Mais Antigos",
    "Organizar de A-Z": "A-Z",
    "Organizar de Z-A": "Z-A",
    "% de desconto": "Maior Desconto"
  };

  function renameSort() {
    document.querySelectorAll("#globo-dropdown-sort_options li[data-sort]").forEach(function (item) {
      const newLabel = labels[item.dataset.sort];

      if (newLabel) {
        item.textContent = newLabel;
        item.setAttribute("aria-label", newLabel);
      }
    });

    const buttonText = document.querySelector(".sort-by-toggle span");

    if (buttonText) {
      const currentText = buttonText.textContent.trim();

      if (buttonLabels[currentText]) {
        buttonText.textContent = buttonLabels[currentText];
      }
    }

    showSortAfterRename();
  }

  function showSortAfterRename() {
    const filterSelection = document.querySelector(".gf-actions .gf-filter-selection");

    if (filterSelection) {
      filterSelection.classList.add("sort-labels-ready");
    }
  }

  [300, 800, 1500, 2500, 4000].forEach(function (delay) {
    setTimeout(renameSort, delay);
  });

  document.addEventListener("click", function (event) {
    if (event.target.closest(".sort-by")) {
      setTimeout(renameSort, 100);
      setTimeout(renameSort, 500);
    }
  });
})();

// FINAL JS PARA ALTERAR NOME DAS OPÇÕES SELECT ORDENAÇÃO


// INICIO JS PARA FILTRAR VARIAÇÕES SECUNDÁRIAS POR SELEÇÃO

(function () {
  document.addEventListener('DOMContentLoaded', function () {
    var jsonEl = document.querySelector(
      'variant-radios script[type="application/json"], variant-selects script[type="application/json"]'
    );
    if (!jsonEl) return;

    var allVariants;
    try { allVariants = JSON.parse(jsonEl.textContent); } catch (_) { return; }
    if (!allVariants || !allVariants.length) return;

    var hasOption2 = allVariants.some(function (v) { return v.option2; });
    if (!hasOption2) return;

    // ── Snapshot dos <option> de cada <select> secundário no carregamento ──
    // Guardamos referências aos elementos (não cópias), para reinserir sem
    // alterar estilos, atributos ou event listeners existentes.
    function snapshotSelect(sel) {
      if (!sel) return null;
      return { el: sel, opts: Array.from(sel.options) };
    }

    var customSelect     = document.querySelector('.product-form__input--custom-second-select select');
    var customSnap       = snapshotSelect(customSelect);

    var variantSelectsEl = document.querySelector('variant-selects');
    var dropdownSel2     = variantSelectsEl && variantSelectsEl.querySelectorAll('select')[1] || null;
    var dropdownSnap     = snapshotSelect(dropdownSel2);

    // ── Reconstrói um <select> com apenas os valores disponíveis ──────────
    function rebuildSelect(snap, availableValues) {
      if (!snap) return;
      var sel      = snap.el;
      var prevVal  = sel.value;

      // Remove todas as options atuais (ficam em memória via snap.opts)
      while (sel.options.length > 0) sel.remove(0);

      // Reinsere apenas as disponíveis — mesmos elementos, sem alterar CSS
      snap.opts.forEach(function (opt) {
        if (availableValues.indexOf(opt.value) !== -1) sel.add(opt);
      });

      // Mantém o valor anterior se ainda disponível; caso contrário, primeiro disponível
      if (availableValues.indexOf(prevVal) !== -1) {
        sel.value = prevVal;
      } else if (sel.options.length > 0) {
        sel.value = sel.options[0].value;
        sel.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    // ── Quais option2 têm estoque para um dado option1 ────────────────────
    function getAvailableOption2(option1Value) {
      var result = [];
      allVariants.forEach(function (v) {
        if (v.option1 === option1Value && v.available && result.indexOf(v.option2) === -1) {
          result.push(v.option2);
        }
      });
      return result;
    }

    // ── Filtro principal ──────────────────────────────────────────────────
    function filterSecondary(option1Value) {
      var available2 = getAvailableOption2(option1Value);

      // Custom picker: reconstrói o <select> visível (funciona em Safari)
      rebuildSelect(customSnap, available2);

      // Button picker: mostra/oculta containers de radio (div, não option)
      if (!customSelect) {
        var variantRadios = document.querySelector('variant-radios');
        if (variantRadios) {
          var option2Fieldset =
            variantRadios.querySelector('fieldset[data-option-position="1"]') ||
            (variantRadios.querySelectorAll('fieldset')[1] || null);

          if (option2Fieldset) {
            var containers = option2Fieldset.querySelectorAll('.varinat-image, .variant-image');
            containers.forEach(function (container) {
              var input = container.querySelector('input[type="radio"]');
              if (!input) return;
              container.style.display = available2.indexOf(input.value) !== -1 ? '' : 'none';
            });
            var checked2 = option2Fieldset.querySelector('input[type="radio"]:checked');
            if (checked2 && available2.indexOf(checked2.value) === -1) {
              for (var i = 0; i < containers.length; i++) {
                if (containers[i].style.display !== 'none') {
                  var firstInput = containers[i].querySelector('input[type="radio"]');
                  if (firstInput) {
                    firstInput.checked = true;
                    firstInput.dispatchEvent(new Event('change', { bubbles: true }));
                  }
                  break;
                }
              }
            }
          }
        }
      }

      // Dropdown picker: reconstrói o segundo <select>
      rebuildSelect(dropdownSnap, available2);
    }

    // Escuta mudança na opção 1 dentro de variant-radios
    var variantRadios = document.querySelector('variant-radios');
    if (variantRadios) {
      var option1Fieldset =
        variantRadios.querySelector('fieldset[data-option-position="0"]') ||
        variantRadios.querySelector('fieldset');

      if (option1Fieldset) {
        option1Fieldset.addEventListener('change', function (e) {
          if (e.target.type === 'radio') filterSecondary(e.target.value);
        });
        var checked1 = option1Fieldset.querySelector('input[type="radio"]:checked');
        if (checked1) filterSecondary(checked1.value);
      }
    }

    // Escuta mudança na opção 1 dentro de variant-selects (dropdown picker)
    var variantSelects = document.querySelector('variant-selects');
    if (variantSelects) {
      var firstSelect = variantSelects.querySelector('select');
      if (firstSelect) {
        firstSelect.addEventListener('change', function () { filterSecondary(this.value); });
        filterSecondary(firstSelect.value);
      }
    }
  });
})();

// FINAL JS PARA FILTRAR VARIAÇÕES SECUNDÁRIAS POR SELEÇÃO


// INICIO JS PARA MINIATURAS ABAIXO DO PRODUTO

(function () {
  var ITEM_SIZE = 88; // 80px + 8px gap

  function syncThumbs(index) {
    var $thumbs = jQuery('.product__media-list-2 .product_thumbnail_item');
    $thumbs.removeClass('active').eq(index).addClass('active');

    var container = jQuery('.product__media-list-2')[0];
    if (!container) return;
    var targetScroll = Math.max(0, index * ITEM_SIZE - container.clientWidth / 2 + ITEM_SIZE / 2);
    container.scrollTo({ left: targetScroll, behavior: 'smooth' });
  }

  function enableDrag(container) {
    var isDown = false;
    var startX, scrollLeft;

    container.addEventListener('mousedown', function (e) {
      isDown = true;
      container.classList.add('is-dragging');
      startX = e.pageX - container.offsetLeft;
      scrollLeft = container.scrollLeft;
    });

    container.addEventListener('mouseleave', function () {
      isDown = false;
      container.classList.remove('is-dragging');
    });

    container.addEventListener('mouseup', function () {
      isDown = false;
      container.classList.remove('is-dragging');
    });

    container.addEventListener('mousemove', function (e) {
      if (!isDown) return;
      e.preventDefault();
      var x = e.pageX - container.offsetLeft;
      var walk = (x - startX) * 1.5;
      container.scrollLeft = scrollLeft - walk;
    });
  }

  function init() {
    if (typeof jQuery === 'undefined') { setTimeout(init, 100); return; }

    var $mainCarousel = jQuery('#main-media-container.single-product');
    if (!$mainCarousel.length || !$mainCarousel.data('owl.carousel')) { setTimeout(init, 100); return; }

    var $thumbStrip = jQuery('.product__media-list-2');
    if (!$thumbStrip.length) return;

    // Drag-to-scroll com mouse (touch já funciona nativamente)
    enableDrag($thumbStrip[0]);

    // Ao trocar slide principal, centraliza miniatura ativa
    $mainCarousel.on('changed.owl.carousel', function (event) {
      if (!event.item) return;
      syncThumbs(event.item.index);
    });

    // Clique em miniatura navega o carousel principal
    $thumbStrip.on('click', '.product_thumbnail_item', function () {
      if ($thumbStrip.hasClass('is-dragging')) return;
      var index = jQuery(this).index();
      $mainCarousel.trigger('to.owl.carousel', [index, 300, true]);
      syncThumbs(index);
    });

    // Ao trocar variação, sincronizar miniatura correspondente à mídia da variante
    document.addEventListener('change', function (e) {
      var picker = e.target.closest('variant-radios, variant-selects');
      if (!picker) return;

      setTimeout(function () {
        var variantInput = document.querySelector('input[name="id"]');
        if (!variantInput) return;

        var jsonScript = picker.querySelector('script[type="application/json"]');
        if (!jsonScript) return;

        var variants;
        try { variants = JSON.parse(jsonScript.textContent); } catch (_) { return; }

        var variant = variants.find(function (v) {
          return String(v.id) === String(variantInput.value);
        });
        if (!variant || !variant.featured_media) return;

        var mediaId = String(variant.featured_media.id);
        var $allThumbs = jQuery('.product__media-list-2 .product_thumbnail_item');
        var idx = -1;
        $allThumbs.each(function (i) {
          var mid = jQuery(this).attr('data-media-id') || '';
          if (mid.slice(-mediaId.length - 1) === '-' + mediaId) { idx = i; return false; }
        });

        if (idx >= 0) {
          $mainCarousel.trigger('to.owl.carousel', [idx, 300, true]);
          syncThumbs(idx);
        }
      }, 150);
    });

    // Estado inicial
    jQuery(window).on('load', function () {
      setTimeout(function () {
        var $current = jQuery('#main-media-container [data-current-variant-media="true"]').first();
        if ($current.length) {
          var idx = parseInt($current.attr('data-media-index'), 10);
          if (!isNaN(idx)) {
            $mainCarousel.trigger('to.owl.carousel', [idx, 0, true]);
            syncThumbs(idx);
            return;
          }
        }
        syncThumbs(0);
      }, 200);
    });

    syncThumbs(0);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { setTimeout(init, 300); });
  } else {
    setTimeout(init, 300);
  }
})();

// FINAL JS PARA MINIATURAS ABAIXO DO PRODUTO


// INICIO JS PARA VARIANTE NO TITULO DO PRODUTO

(function () {
  function updateTitleVariant() {
    var variantInput = document.querySelector('input[name="id"]');
    if (!variantInput) return;

    var jsonEl = document.querySelector(
      'variant-radios script[type="application/json"], variant-selects script[type="application/json"]'
    );
    if (!jsonEl) return;

    var variants;
    try { variants = JSON.parse(jsonEl.textContent); } catch (_) { return; }

    var variant = variants.find(function (v) { return String(v.id) === String(variantInput.value); });
    if (!variant) return;

    var parts = [];
    if (variant.option1 && variant.option1 !== 'Default Title') parts.push(variant.option1);
    if (variant.option2) parts.push(variant.option2);
    if (variant.option3) parts.push(variant.option3);

    var span = document.getElementById('product-title-variant');
    if (span) span.textContent = parts.length ? ' — ' + parts.join(' / ') : '';
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.addEventListener('change', function (e) {
      if (!e.target.closest('variant-radios, variant-selects')) return;
      setTimeout(updateTitleVariant, 150);
    });
    updateTitleVariant();
  });
})();

// FINAL JS PARA VARIANTE NO TITULO DO PRODUTO


// INICIO JS PARA ABRIR CARRINHO AO ADICIONAR PRODUTO

(function () {
  function abrirCarrinho() {
    var notif = document.querySelector('.cart-notification');
    var overlay = document.querySelector('.cart-overlay');
    if (notif) notif.classList.add('active');
    if (overlay) overlay.classList.add('active');
    document.body.classList.add('cart-overflow');
  }

  document.addEventListener('DOMContentLoaded', function () {
    // Estratégia 1: observa quando o conteúdo do carrinho é atualizado pelo AJAX
    var cartProduct = document.getElementById('cart-notification-product');
    if (cartProduct) {
      var obs = new MutationObserver(abrirCarrinho);
      obs.observe(cartProduct, { childList: true, subtree: true });
    }

    // Estratégia 2: intercepta submit do formulário de adicionar ao carrinho
    // Usado como fallback se a estratégia 1 não disparar
    document.addEventListener('submit', function (e) {
      if (!e.target.closest('[data-type="add-to-cart-form"]')) return;

      var cartIconBubble = document.getElementById('cart-icon-bubble');
      if (!cartIconBubble) return;

      var fallbackObs = new MutationObserver(function () {
        fallbackObs.disconnect();
        abrirCarrinho();
      });
      fallbackObs.observe(cartIconBubble, { childList: true, subtree: true, characterData: true });

      // Timeout de segurança: se o observer não disparar em 3s, interrompe
      setTimeout(function () { fallbackObs.disconnect(); }, 3000);
    });
  });
})();

// FINAL JS PARA ABRIR CARRINHO AO ADICIONAR PRODUTO


// INICIO JS PARA FAIXA MARQUEE ACOMPANHAR O HEADER FIXO

  // Não mexe em shop.js (não editável): replica a mesma condição que
  // shop.js usa para fixar o header (adjustFixedHeader), só para também
  // fixar a faixa marquee acima dele e empurrar o header para baixo pela
  // altura da faixa, em vez de sobrepor.
  document.addEventListener('DOMContentLoaded', function () {
    if (typeof jQuery === 'undefined') return;

    function adjustFixedMarquee() {
      var $marquee = jQuery('#shopify-section-marquee-text-section');
      if (!$marquee.length) return;

      var marqueeHeight = $marquee.outerHeight() || 0;
      var headerHeight = jQuery('#header').height();
      var navmenuHeightDesktop = jQuery('.wrapper-nav .navfullwidth').height();
      var navfullwidthHeightDesktop = headerHeight + navmenuHeightDesktop;
      var navHeightMobile = headerHeight;

      var isDesktop = window.matchMedia('(min-width: 992px)').matches;
      var threshold = isDesktop ? navfullwidthHeightDesktop : navHeightMobile;
      var $fixedTarget = isDesktop ? jQuery('.header-top') : jQuery('.mobile-width');

      if (jQuery(window).scrollTop() > threshold) {
        $marquee.addClass('fixed-marquee');
        $fixedTarget.css('top', marqueeHeight);
      } else {
        $marquee.removeClass('fixed-marquee');
        $fixedTarget.css('top', '');
      }
    }

    adjustFixedMarquee();
    jQuery(window).on('scroll resize', adjustFixedMarquee);
  });

// FINAL JS PARA FAIXA MARQUEE ACOMPANHAR O HEADER FIXO


// INICIO JS PARA LIMITAR VARIAÇÕES POR LINHA NOS CARDS DE PRODUTO

  // O Liquid renderiza TODAS as variações (product-card-grid.liquid e
  // globo.filter.product.liquid); aqui medimos a posição real de cada pill
  // pra saber quantas cabem em 1 ou 2 linhas (configurável em Configurações
  // do tema > Product > "Linhas de variações exibidas") e ajustamos o "+N"
  // de acordo. Não dá pra calcular isso no Liquid porque cada variação tem
  // um texto de tamanho diferente (ex: "P" x "Casal padrão").
  (function () {
    function measureRows(tags, containerTop) {
      var rows = [];
      tags.forEach(function (tag) {
        var top = Math.round(tag.getBoundingClientRect().top - containerTop);
        var row = rows.filter(function (r) { return Math.abs(r.top - top) < 2; })[0];
        if (!row) {
          row = { top: top, items: [] };
          rows.push(row);
        }
        row.items.push(tag);
      });
      rows.sort(function (a, b) { return a.top - b.top; });
      return rows;
    }

    function fitVariantTags(container) {
      var maxLines = parseInt(container.getAttribute('data-max-lines'), 10);
      if (!maxLines || container.offsetParent === null) return;

      var tags = Array.prototype.slice.call(
        container.querySelectorAll('.variant-size-tag:not(.variant-size-more)')
      );
      var moreBadge = container.querySelector('.variant-size-tag.variant-size-more');
      if (!tags.length) return;

      // Mostra tudo pra medir a posição real de cada item antes de decidir o que esconder
      tags.forEach(function (t) { t.hidden = false; });
      if (moreBadge) moreBadge.hidden = true;

      var containerTop = container.getBoundingClientRect().top;
      var rows = measureRows(tags, containerTop);

      if (rows.length <= maxLines) return;

      var visible = [];
      for (var i = 0; i < maxLines; i++) {
        visible = visible.concat(rows[i].items);
      }
      var hiddenCount = tags.length - visible.length;

      tags.forEach(function (t) {
        t.hidden = visible.indexOf(t) === -1;
      });

      if (!moreBadge) return;

      moreBadge.hidden = false;
      moreBadge.textContent = '+' + hiddenCount;

      // Garante que o próprio "+N" também caiba dentro do limite de linhas;
      // se ele empurrar pra uma linha extra, esconde mais um item real.
      var lastRowTop = rows[maxLines - 1].top;
      var attempts = 0;
      while (attempts < tags.length && visible.length > 0) {
        var badgeTop = Math.round(moreBadge.getBoundingClientRect().top - containerTop);
        if (badgeTop <= lastRowTop + 2) break;
        var last = visible.pop();
        last.hidden = true;
        hiddenCount++;
        moreBadge.textContent = '+' + hiddenCount;
        attempts++;
      }
    }

    function fitAll() {
      document.querySelectorAll('.variant-size-tags[data-max-lines]').forEach(fitVariantTags);
    }

    document.addEventListener('DOMContentLoaded', function () {
      var containers = document.querySelectorAll('.variant-size-tags[data-max-lines]');
      if (!containers.length) return;

      if ('ResizeObserver' in window) {
        var lastWidths = new WeakMap();
        var ro = new ResizeObserver(function (entries) {
          entries.forEach(function (entry) {
            var container = entry.target;
            var width = Math.round(entry.contentRect.width);
            // Ignora disparos causados pelo nosso próprio hide/show (só a altura muda)
            if (lastWidths.get(container) === width) return;
            lastWidths.set(container, width);
            fitVariantTags(container);
          });
        });
        containers.forEach(function (el) { ro.observe(el); });
      } else {
        fitAll();
        var resizeTimer;
        window.addEventListener('resize', function () {
          clearTimeout(resizeTimer);
          resizeTimer = setTimeout(fitAll, 200);
        });
      }
    });
  })();

// FINAL JS PARA LIMITAR VARIAÇÕES POR LINHA NOS CARDS DE PRODUTO


// INICIO JS PARA COLAPSAR GRUPOS DO FILTRO NATIVO (SIDEBAR)

  // Delegado no document (não em cada .facets__summary) porque o
  // facets.js substitui o HTML do filtro inteiro via AJAX a cada busca —
  // um listener direto seria perdido a cada atualização, o delegado não.
  // Escopo em ".collection-facets" (não "#main-collection-filters"):
  // a sidebar visível de verdade é renderizada por Ishi_sidebar.liquid
  // (#FacetFiltersFormSidebar), que fica fora de #main-collection-filters.
  document.addEventListener('click', function (e) {
    var summary = e.target.closest('.collection-facets .facets__summary');
    if (!summary) return;
    var group = summary.closest('.facets__disclosure');
    if (!group) return;
    group.classList.toggle('is-collapsed');
  });

  // O checkbox ".more_toggle" ("Mostrar mais/menos") fica dentro do mesmo
  // <form> dos filtros de verdade. facets.js escuta "input" no form
  // inteiro pra disparar a busca via AJAX — sem isso aqui, marcar o
  // "Mostrar mais" também dispara uma busca, que devolve o HTML do
  // servidor com o checkbox desmarcado de novo (ele não é um filtro de
  // verdade, não existe na URL), fechando a lista na hora. Intercepta em
  // fase de captura (roda antes do listener do form) e impede a
  // propagação só pra esse checkbox específico.
  document.addEventListener('input', function (e) {
    if (e.target.classList && e.target.classList.contains('more_toggle')) {
      e.stopPropagation();
    }
  }, true);
  document.addEventListener('change', function (e) {
    if (e.target.classList && e.target.classList.contains('more_toggle')) {
      e.stopPropagation();
    }
  }, true);

// FINAL JS PARA COLAPSAR GRUPOS DO FILTRO NATIVO (SIDEBAR)


// INICIO JS PARA DROPDOWN CUSTOMIZADO DO "ORDENAR POR" (DESKTOP)

  // O <select> nativo abre o menu do sistema operacional, que não dá pra
  // estilizar (cada navegador/SO desenha do seu jeito). Aqui construímos
  // um menu próprio (botão + lista) em cima do select nativo: o select
  // continua existindo escondido, só que agora controlado pelo nosso menu
  // — assim o restante do código (facets.js, auto-submit do formulário)
  // continua funcionando sem precisar mexer em mais nada.
  function buildCustomSortDropdown(selectEl) {
    if (!selectEl || selectEl.dataset.customDropdownReady === '1') return;

    var wrapper = selectEl.closest('.select');
    if (!wrapper) return;

    selectEl.dataset.customDropdownReady = '1';

    var custom = document.createElement('div');
    custom.className = 'custom-select';

    var trigger = document.createElement('button');
    trigger.type = 'button';
    trigger.className = 'custom-select__trigger';
    trigger.textContent = selectEl.options[selectEl.selectedIndex]
      ? selectEl.options[selectEl.selectedIndex].text
      : '';

    var list = document.createElement('ul');
    list.className = 'custom-select__list';
    list.hidden = true;

    Array.prototype.forEach.call(selectEl.options, function (opt) {
      var item = document.createElement('li');
      item.textContent = opt.text;
      item.dataset.value = opt.value;
      if (opt.selected) item.classList.add('is-selected');
      list.appendChild(item);
    });

    custom.appendChild(trigger);
    custom.appendChild(list);
    wrapper.appendChild(custom);
    wrapper.classList.add('select--custom-active');

    // Esconde o select nativo direto via JS (display:none tem prioridade
    // máxima, sem depender de especificidade de CSS) — se por algum
    // motivo a classe .select--custom-active não escondesse o select via
    // CSS, os dois ficavam visíveis ao mesmo tempo (um dropdown nativo e
    // um customizado, duplicado).
    selectEl.style.display = 'none';
    var caretIcon = wrapper.querySelector('.icon-caret');
    if (caretIcon) caretIcon.style.display = 'none';

    function closeList() {
      list.hidden = true;
      custom.classList.remove('is-open');
    }

    trigger.addEventListener('click', function (e) {
      e.stopPropagation();
      var isOpen = !list.hidden;
      closeList();
      if (!isOpen) {
        list.hidden = false;
        custom.classList.add('is-open');
      }
    });

    list.addEventListener('click', function (e) {
      var item = e.target.closest('li');
      if (!item) return;

      Array.prototype.forEach.call(list.children, function (li) {
        li.classList.toggle('is-selected', li === item);
      });
      trigger.textContent = item.textContent;

      selectEl.value = item.dataset.value;
      selectEl.dispatchEvent(new Event('input', { bubbles: true }));
      selectEl.dispatchEvent(new Event('change', { bubbles: true }));

      closeList();
    });

    document.addEventListener('click', function (e) {
      if (!custom.contains(e.target)) closeList();
    });

    document.addEventListener('keyup', function (e) {
      if (e.key === 'Escape') closeList();
    });
  }

  function initCustomSortDropdowns() {
    // facets.js copia o HTML inteiro do form do topo (#FacetFiltersForm,
    // com o #SortBy de verdade dentro) pra dentro de
    // #FacetFiltersFormSidebar a cada filtro aplicado — isso cria um
    // id="SortBy" DUPLICADO na página (inválido, mas o navegador tolera).
    // document.getElementById só acha o primeiro, então usamos
    // querySelectorAll aqui: o primeiro vira o dropdown customizado, e
    // qualquer cópia extra é escondida à força (não dependemos só da
    // regra "#FacetFiltersFormSidebar .collection-filters__item
    // {display:none}" do base.css, caso ela não esteja pegando por
    // algum motivo de especificidade).
    var selects = document.querySelectorAll('[id="SortBy"]');
    selects.forEach(function (select, index) {
      if (index === 0) {
        buildCustomSortDropdown(select);
      } else {
        select.style.display = 'none';
        var container = select.closest('.collection-filters__item') || select.closest('.select');
        if (container) container.style.display = 'none';
      }
    });
  }

  initCustomSortDropdowns();

  // facets.js troca o innerHTML de ".sorting" inteiro a cada filtro
  // aplicado (renderAdditionalElements) E copia o form do topo pra
  // dentro de #FacetFiltersFormSidebar (renderFilters) — os dois criam/
  // recriam elementos "#SortBy". Observamos o container maior
  // (#main-collection-filters), não só um ".sorting" específico, porque
  // depois da cópia pode existir mais de um ".sorting" na página e
  // document.querySelector pegaria só o primeiro (que podia nem ser o
  // que mudou).
  var filtersContainer = document.getElementById('main-collection-filters');
  if (filtersContainer && window.MutationObserver) {
    new MutationObserver(initCustomSortDropdowns).observe(filtersContainer, {
      childList: true,
      subtree: true
    });
  }

// FINAL JS PARA DROPDOWN CUSTOMIZADO DO "ORDENAR POR" (DESKTOP)


// INICIO JS PARA ORDENAÇÃO NO MOBILE (barra separada do filtro)

  // O select visível #SortBy-mobile fica FORA do <form> da gaveta de
  // filtros (a classe "mobile-facets" que esse form usa deixa o
  // elemento position:fixed/tela cheia — não dá pra colocar algo que
  // precisa ficar sempre visível, como esse select, dentro dele). Em vez
  // disso, ao trocar a ordenação, copiamos o valor pro campo escondido
  // #SortBySync-mobile (esse sim dentro do form de verdade) e disparamos
  // "input" nele — facets.js já escuta "input" no form inteiro pra
  // atualizar a busca via AJAX, reaproveitando os outros filtros já
  // marcados.
  document.addEventListener('change', function (e) {
    if (!e.target.matches || !e.target.matches('#SortBy-mobile')) return;
    var syncField = document.getElementById('SortBySync-mobile');
    if (!syncField) return;
    syncField.value = e.target.value;
    syncField.dispatchEvent(new Event('input', { bubbles: true }));
    syncField.dispatchEvent(new Event('change', { bubbles: true }));
  });

// FINAL JS PARA ORDENAÇÃO NO MOBILE (barra separada do filtro)


// INICIO JS PARA ROLAGEM INFINITA NA COLEÇÃO (sem paginação por número)

  // O link #CollectionLoadMoreLink já é um <a href> de verdade pra
  // próxima página (funciona sozinho sem JS, bom pra SEO/crawlers). Com
  // JS, em vez de deixar o clique navegar, buscamos essa URL via fetch e
  // anexamos os novos produtos na mesma lista — e também carregamos
  // automaticamente conforme o visitante rola até perto do final (via
  // IntersectionObserver), sem precisar clicar.
  function initCollectionLoadMore() {
    var trigger = document.getElementById('CollectionLoadMoreLink');
    if (!trigger || trigger.dataset.loadMoreReady === '1') return;
    trigger.dataset.loadMoreReady = '1';

    var isLoading = false;

    function loadNextPage() {
      if (isLoading) return;
      var url = trigger.getAttribute('href');
      if (!url) return;

      isLoading = true;
      trigger.classList.add('is-loading');

      fetch(url)
        .then(function (response) { return response.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');

          var list = document.getElementById('product-grid');
          var newItems = doc.querySelectorAll('#product-grid > li');
          newItems.forEach(function (li) {
            list.appendChild(li);
          });

          // A paginação da Shopify é calculada antes das regras Liquid que
          // removem produtos/variantes sem estoque. Por isso, uma página pode
          // existir no paginate, mas chegar aqui sem nenhum <li>. Quando isso
          // acontecer, avançamos automaticamente para o próximo lote em vez
          // de deixar o visitante parado em uma carga aparentemente vazia.
          var newTrigger = doc.getElementById('CollectionLoadMoreLink');
          if (!newItems.length && newTrigger) {
            trigger.setAttribute('href', newTrigger.getAttribute('href'));
            isLoading = false;
            trigger.classList.remove('is-loading');
            loadNextPage();
            return;
          }

          // Soma a contagem do lote novo ao total já exibido (em vez de
          // substituir, já que não existe mais "página X de Y").
          var currentCountEl = document.getElementById('CollectionItemCountNumber');
          var newCountEl = doc.getElementById('CollectionItemCountNumber');
          if (currentCountEl && newCountEl) {
            var total = (parseInt(currentCountEl.textContent, 10) || 0) + (parseInt(newCountEl.textContent, 10) || 0);
            currentCountEl.textContent = total;
          }
          var labelEl = document.getElementById('CollectionItemCountLabel');
          if (labelEl) {
            labelEl.textContent = 'itens';
          }

          // Se o lote novo ainda tem próxima página, atualiza o link
          // pra ela; senão, não tem mais o que carregar — remove o
          // gatilho.
          if (newTrigger) {
            trigger.setAttribute('href', newTrigger.getAttribute('href'));
          } else {
            observer.unobserve(trigger);
            trigger.closest('.pagination-view') && trigger.closest('.pagination-view').remove();
          }

          isLoading = false;
          trigger.classList.remove('is-loading');
        })
        .catch(function () {
          isLoading = false;
          trigger.classList.remove('is-loading');
        });
    }

    trigger.addEventListener('click', function (e) {
      e.preventDefault();
      loadNextPage();
    });

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) loadNextPage();
      });
    }, { rootMargin: '600px' });

    observer.observe(trigger);
  }

  initCollectionLoadMore();

  // Quando um filtro/ordenação é aplicado, facets.js substitui o
  // conteúdo inteiro de #ProductGridContainer por uma página nova — o
  // que já "reseta" a rolagem infinita sozinho (lista volta a ter só o
  // primeiro lote). Só precisamos reconstruir o gatilho/observer pro
  // #CollectionLoadMoreLink novo que vem nesse HTML.
  var productGridContainer = document.getElementById('ProductGridContainer');
  if (productGridContainer && window.MutationObserver) {
    new MutationObserver(initCollectionLoadMore).observe(productGridContainer, {
      childList: true
    });
  }

// FINAL JS PARA ROLAGEM INFINITA NA COLEÇÃO (sem paginação por número)


